import state from './state'
import mutations from './mutations'
import actions from './actions'

/*
|---------------------------------------------------------------------
| Board Vuex Store
|---------------------------------------------------------------------
*/
export default {
    namespaced: true,
    state,
    mutations,
    actions
}